import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Typography } from '@mui/material';

const NumberBox = ({ className, title, value, ...rest }) => {
  return (
    <Card
      className={className}
      sx={{
        p: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      {...rest}
    >
      <Box flexGrow={1}>
        <Typography
          component="h3"
          gutterBottom
          variant="overline"
          color="textSecondary"
        >
          {title}
        </Typography>
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <Typography variant="h3" color="textPrimary">
            {value}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

NumberBox.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};

export default NumberBox;
